import Http from '@/utils/Http'

export default {
  get(route, params = {}, config) {
    return Http.get({ path: `awp-signin${route}`, params }, config).then(response => response, (error) => {
      // response.result 为null的时候, 返回response
      throw (error)
      // doucument.write('网络异常，请稍后重试')
    })
  },
  post(route, params = {}, config) {
    return Http.post({ path: `awp-signin${route}`, params }, config).then(response => response, (error) => {
      throw (error)
      // doucument.write('网络异常，请稍后重试')
    })
  },


}
